module.exports = __webpack_public_path__ + "img/p39.9378b8f0.svg";